<template>
  <div class="nx-clipping-tool-carousel-wrapper">
    <div class="nx-clipping-tool-carousel-wrapper__body">
      <img
        :alt="clipping.name"
        :id="clipping.id"
        :src="clipping.src"
        class="clipping"
        ref="clipping"
      >
    </div>
    <v-layout wrap class="actions">
      <v-flex>
        <v-btn icon @click="prev">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex text-xs-right>
        <v-btn icon @click="next">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'nx-clipping-tool-carousel',
  props: {
    content: Object,
    value: Number,
  },
  computed: {
    clipping() {
      if (this.content
        && this.content.clippings) {
        return this.content.clippings[this.value];
      }
      return {};
    },
  },
  methods: {
    next() {
      this.goTo(this.content.selection + 1);
    },
    prev() {
      this.goTo(this.content.selection - 1);
    },
    goTo(index) {
      const selection = (this.content.clippings.length + index)
        % this.content.clippings.length;
      this.$emit('input', selection);
    },
  },
  created() {
    const nextKeys = ['ArrowRight', 'n']; // Right arrow or 'n'.
    const prevKeys = ['ArrowLeft', 'p']; // Left arrow or 'p'.
    this.eventListener = window.addEventListener('keydown', (e) => {
      if (nextKeys.includes(e.key)) this.next();
      else if (prevKeys.includes(e.key)) this.prev();
    });
  },
  destroyed() {
    window.removeEventListener('keydown', this.eventListener);
  },
};
</script>

<style lang="stylus">
.nx-clipping-tool-carousel-wrapper {
  height: calc(100vh - 64px);

  &__body {
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    height: 100%
    min-height: 100%
    max-height: 100%
  }
}

.nx-clipping-tool-body {

  .nx-carousel {

    .actions {
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      display: flex
      justify-content: space-between
      align-items center
      .flex {
        flex-grow: 0
      }
    }

    .clipping {
      display: block
      max-width: 100%
      max-height: 90%;
      margin: -64px auto 0;
      align-self: center
      object-fit: contain
    }
  }
}
</style>
